<template>
  <div class="bg-white">
    <div class="min-h-0 search--list overflow-y-auto overflow-x-hidden px-2">
      <SearchMainSection />
      <div class="flex">
        <button data-vs-button="show-opts" @click="showMoreOptions"
          class="focus:outline-none text-zt-md ml-auto text-zt-secondary-200">
          <div class="flex items-baseline">
            <span class="text-zt-secondary-200">{{ $t("message.inicioComponent.advanceSearch") }}</span>
            <zt-icon class="pl-1" name="arrow-down" />
          </div>
        </button>
      </div>
      <div v-show="advanceOptions">
        <EmployeeSection />
        <SearchDocumentSection />
        <SearchEformSection />
      </div>
    </div>
    <div class="text-center bg-white">
      <div class="pt-2">
        <zt-button data-vs-button="search" gtm-class="zt-gtm-documents-search-search" @click="searchDocuments(true)"
          icon="search">{{ $t("message.HeaderComponent.search") }}</zt-button>
      </div>
    </div>
  </div>
</template>

<script>
import SearchMainSection from './SearchMainSection'
import EmployeeSection from './EmployeeSection'
import SearchDocumentSection from './SearchDocumentSection'
import SearchEformSection from './SearchEformSection'
import Search from '@/apiClient/Search'
import { addFilters } from '../utils'

export default {
  name: 'SearchList',
  components: {
    SearchMainSection,
    EmployeeSection,
    SearchDocumentSection,
    SearchEformSection
  },
  inject: [
    'setHaveResults',
    'setResultsEforms',
    'setDocuments',
    'setInitialStatus',
    'setOrderBy',
    'setOrderType',
    'setPagination',
    'setTotal',
    'setPageCount',
    'store',
    'setFilters'
  ],
  data() {
    return {
      searchConfig: new Search(),
      advanceOptions: false
    }
  },
  computed: {
    queryParams() {
      return {
        orderBy: this.store.orderBy,
        orderType: this.store.orderType,
        pagination: this.store.pagination
      }
    }
  },
  watch: {
    queryParams() {
      this.searchDocuments()
    }
  },
  async mounted() {
    this.searchForUnsignedDocumentsAndClearFilter()
  },
  methods: {
    resetParams() {
      this.setOrderBy('id')
      this.setOrderType('desc')
      this.setPagination({
        rows: 20,
        page: 1
      })
    },
    async searchForUnsignedDocumentsAndClearFilter() {
      if (this.$route.params.loadUnsignedDocs) {
        const { filters } = this.store
        const notSignedFilter = addFilters({ ...filters }, ['signStatus', ['NO FIRMADO']])
        this.setFilters(notSignedFilter)
        await this.searchDocuments(true)
      }
    },
    async searchDocuments(clicked) {
      if (clicked) {
        this.resetParams()
      }
      const { filters, pagination, orderBy, orderType } = this.store
      const params = `pagination=${pagination.rows},${pagination.page},0&orderBy=${orderBy}&orderType=${orderType}`

      const [responseSearch, responseEforms] = await Promise.allSettled([
        this.searchConfig.SearchDocuments(filters, params),
        this.searchConfig.ResultEforms(filters)
      ])

      if (responseSearch.status === 'rejected') {
        this.setHaveResults(false)
        this.setInitialStatus(false)
        this.setDocuments([])
        return
      }

      const {
        value: {
          data: { data, pagination: responsePagination }
        }
      } = responseSearch

      this.setHaveResults(true)
      this.setInitialStatus(false)
      this.setDocuments(data)
      this.setTotal(responsePagination.total)
      this.setPageCount(responsePagination.pageCount)

      if (responseEforms.status === 'rejected') {
        return this.setResultsEforms([])
      }

      const {
        value: {
          data: { data: filtersEformsData }
        }
      } = responseEforms

      this.setResultsEforms(filtersEformsData)
    },
    showMoreOptions() {
      this.advanceOptions = !this.advanceOptions
    }
  }
}
</script>
<style scoped>
.search--list {
  height: calc(100vh - 74px - 70px - 60px);
}
</style>
